import { AdvertisingPage } from 'presentation/app/modules/Advertising/pages';

export const AdvertisingTabContent = () => {
  return <AdvertisingPage />;
};
